import { Component, Inject, OnInit } from '@angular/core';
import { ControlContainer, FormGroupDirective, FormsModule, ReactiveFormsModule, UntypedFormControl, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogRef } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { BoxGroupInfos } from 'src/app/models/box-group-infos';
import { BoxesStateService } from 'src/app/services/state/boxes-state.service';
import { DialogMoveToBoxData } from './models/dialog-move-to-box-data';

import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';

export interface DialogDataMoveToBox {
    boxId: string;
    comment: string;
}

@Component({
    selector: 'app-move-to-box',
    templateUrl: './move-to-box.component.html',
    styleUrls: ['./move-to-box.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
    imports: [MatCardModule, MatFormFieldModule, MatSelectModule, FormsModule, ReactiveFormsModule, MatOptionModule, MatInputModule, MatButtonModule, MatDialogClose]
})
export class MoveToBoxComponent implements OnInit {
    /**
     * Liste des groupes de bannettes auxquels ait accès l'utilisateur.
     */
    public boxGroupInfo: BoxGroupInfos[];

    /**
     * Id de la bannette actuelle.
     */
    public currentBoxId: string;

    /**
     * Contrôle de formulaire pour saisir le commentaire.
     */
    public commentFormControl = new UntypedFormControl();

    /**
     * Contrôle de formulaire pour selectionner la bannette de destination.
     */
    public boxFormControl = new UntypedFormControl(null, [Validators.required]);

    /**
     * Constructeur.
     * @param boxesStateService
     * @param dialogRef
     * @param data
     */
    constructor(
        private boxesStateService: BoxesStateService,
        public dialogRef: MatDialogRef<MoveToBoxComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogMoveToBoxData
    ) {
        this.currentBoxId = this.data.boxId;
    }

    /**
     * Appelée à l'initialisation du composant.
     */
    ngOnInit(): void {
        this.boxGroupInfo = this.boxesStateService.getBoxesGroupsList();
    }

    /**
     * Appelé lorsque l'utilisateur clique sur le bouton 'Annuler'.
     */
    public cancel(): void {
        this.dialogRef.close();
    }
}
